<template>
  <div class="modal-outer" @click="handleOutsideClick">
    <div class="modal-inner" @click.stop>
      <button v-if="imageLoaded" @click="handleCloseBtn" class="close-btn" type="button">
        <i class="bi bi-x-lg"></i>
      </button>

      <div class="img-container">
        <div class="selected-img-box">
          <img
              v-if="selectedImage || imageList.length > 0"
              :src="selectedImage ? selectedImage.url : imageList[0].url"
              @load="onImageLoad"
              alt=""
          />
        </div>

        <ul class="img-wrapper" v-if="imageList.length > 1 && imageLoaded">
          <li
              :class="{ active: imgIdx === currentImageIdx }"
              class="img-item"
              v-for="(img, imgIdx) in imageList"
              :key="imgIdx"
              @click="selectImage(img, imgIdx)"
          ></li>
        </ul>

        <div v-if="currentImageIdx > 0 && imageLoaded" class="arrow-box left" @click="previousImage()">
          <i class="bi bi-chevron-left"></i>
        </div>
        <div v-if="currentImageIdx + 1 < imageList.length && imageLoaded" class="arrow-box right" @click="nextImage()">
          <i class="bi bi-chevron-right"></i>
        </div>
      </div>

      <div class="content-box" v-if="imageLoaded">
        <h3>{{ selectedGallery.title }}</h3>
        <p>{{ formatDate(selectedGallery.createdAt) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/utils/dateUtils";

export default {
  name: "GalleryImageModal",
  props: {
    selectedGallery: null,
    closeBtn: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      selectedImage: null,
      currentImageIdx: 0,
      imageLoaded: false
    };
  },
  computed: {
    imageList() {
      return this.selectedGallery?.imageFiles?.length > 0
          ? this.selectedGallery.imageFiles
          : this.selectedGallery?.attachedFiles || [];
    }
  },
  mounted() {
    if (this.imageList.length > 0) {
      this.selectedImage = this.imageList[0];
      this.currentImageIdx = 0;
      this.imageLoaded = true;
    }
  },
  methods: {
    formatDate,
    selectImage(img, imgIdx) {
      this.selectedImage = img;
      this.currentImageIdx = imgIdx;
      this.imageLoaded = false;
    },
    onImageLoad() {
      this.imageLoaded = true;
    },
    handleOutsideClick() {
      this.handleCloseBtn();
    },
    handleCloseBtn() {
      this.imageLoaded = false;
      this.closeBtn();
    },
    previousImage() {
      this.selectedImage = this.imageList[--this.currentImageIdx];
    },
    nextImage() {
      this.selectedImage = this.imageList[++this.currentImageIdx];
    }
  }
};
</script>

<style scoped lang="scss">
.modal-outer {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);

  .modal-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 1000px;
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;

    .close-btn {
      position: absolute;
      top: -45px;
      right: 10px;
      background-color: transparent;

      i {
        font-size: 25px;
        color: #fff;
      }
    }

    .img-container {
      position: relative;

      .arrow-box {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 32px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.6);
        cursor: pointer;

        i {
          font-size: 18px;
          color: #333;
        }

        &.left {
          left: 20px;
        }

        &.right {
          right: 20px;
        }
      }

      img {
        width: 100%;
        max-height: 70vh;
        object-fit: cover;
      }

      .selected-img-box {
        max-width: 1000px;
        margin: 0 auto;
        border-radius: 10px;
        overflow: hidden;
      }

      .img-wrapper {
        display: flex;
        justify-content: center;
        transform: translateY(-30px);
        margin: 0 auto;

        .img-item {
          width: 6px;
          height: 6px;
          margin: 0 3px;
          border-radius: 50%;
          background-color: #c7c7c7;
          cursor: pointer;

          &.active {
            background-color: #fff;
          }
        }
      }
    }

    .content-box {
      text-align: left;
      padding: 20px 0;
      color: #fff;

      h3 {
        font-size: 18px;
      }

      p {
        color: #ddd;
        font-size: 15px;
        margin-top: 10px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .modal-outer .modal-inner .close-btn {
    top: -30px;
  }

  .modal-outer .modal-inner .close-btn i {
    font-size: 20px;
  }

  .modal-outer .modal-inner .img-container .arrow-box {
    width: 28px;
    height: 28px;
  }

  .modal-outer .modal-inner .img-container .arrow-box i {
    font-size: 16px;
  }

  .modal-outer .modal-inner .content-box h3 {
    font-size: 17px;
  }
}
</style>
